import {
  ModalContainer,
  ModalLayoutFullScreen,
} from '@kanda-libs/ks-design-library';

import Container from './JobModal-container';
import { Header } from './components';
import JobDetails from '../../../JobDetails';
import { JOB_MODAL_ID } from './JobModal-constants';

const ViewComponent = ({}) => (
  <Container>
    {({ ...props }) => (
      <ModalContainer id={JOB_MODAL_ID}>
        {({ handleClose }) => (
          <ModalLayoutFullScreen
            noBorder
            header={<Header onClick={handleClose} />}
          >
            <div className="-mt-6 h-full">
              <JobDetails {...props} />
            </div>
          </ModalLayoutFullScreen>
        )}
      </ModalContainer>
    )}
  </Container>
);

ViewComponent.displayName = 'JobButton-JobModal-view';

export default ViewComponent;
